<!--
Author: TangChen
Date: 2018-11-09
Desc: 用户持有银行卡信息组件，由index.js 配置引入
-->
<template>
    <div class="bizcomp-hold-bank">
        <div class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">我的银行卡</div>
        </div>
        <div class="hold-bank-list-contain">
            <div v-for="(bank, index) in bankInfo" :key="index" class="hold-bank-list">
                <div
                    :class="
                        'bank-card ' +
                        (index % 3 < 2 ? 'margin-right-25 ' : '') +
                        (index > 2 ? 'margin-top-16' : '')
                    "
                >
                    <div class="bank-info">
                        <div class="bank-img">
                            <img :src="$util.getImg(bank.bankcode)" alt="" />
                        </div>
                        <div class="bank-name">
                            <span class="t">{{ $cache.getDict("110080", bank.bankcode) }}</span>
                            <span class="c flex">
                                <!-- <span v-if="bank.paycenterid != '0001'">
                                    {{
                                        $cache.getDict("110079", bank.paycenterid) +
                                        (bank.hkcardflag === "1" ? "(汇款支付)" : "(在线支付)")
                                    }}
                                </span>
                                <span v-else>
                                    {{ $cache.getDict("110079", bank.paycenterid) }}
                                </span> -->
                                <span>
                                    {{ $cache.getDict("110079", bank.paycenterid) }}
                                </span>
                                <!-- <span
                                    v-if="bank.hkcardflag == '1'"
                                    class="ml-10"
                                    style="margin-left: 10px"
                                >
                                    汇款交易方式
                                </span> -->
                            </span>
                        </div>
                    </div>
                    <p class="bank-num">
                        {{ $util.getNewCard(bank.depositcard) }}
                    </p>
                    <div v-if="$util.getConfig().hideFunc" class="bank-action">
                        <el-tooltip
                            v-if="bank.paycenterid != '0001'"
                            :content="bank.activeDisabledTip"
                            :manual="!bank.activeDisabledTip"
                        >
                            <button
                                :class="[
                                    'bank-btn',
                                    bank.activeDisabledTip ? 'bank-btn-disabled' : ''
                                ]"
                                :disabled="!!bank.activeDisabledTip"
                                v-on:click="activeHandle(bank)"
                            >
                                激活
                            </button>
                        </el-tooltip>
                        <!-- <el-button
                            v-if="bank.authenticateflag === '2'"
                            size="mini"
                            v-on:click.once="
                                $router.push({
                                    name: 'modifybank',
                                    query: bank,
                                })
                            "
                        >
                            修改
                        </el-button> -->
                        <el-tooltip
                            v-if="changeCardDisplay"
                            content="银行卡未激活"
                            :manual="!!bank.activeDisabledTip"
                        >
                            <button
                                :class="[!bank.activeDisabledTip ? 'bank-btn-disabled' : '']"
                                :disabled="!bank.activeDisabledTip"
                                class="bank-btn"
                                v-on:click="toChangeCard(bank)"
                            >
                                换卡
                            </button>
                        </el-tooltip>
                        <el-tooltip
                            v-if="$util.getBusinessModule('0B6')"
                            content="银行卡解绑即交易账户销户"
                        >
                            <button
                                class="bank-btn"
                                v-on:click="
                                    deleteBank(bank.bankcardid, bank.paycenterid, bank.signstatus)
                                "
                            >
                                解绑
                            </button>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div>
                <div
                    v-if="!$util.getConfig().hideFunc && bankInfo.length === 0"
                    class="bank-card-add"
                >
                    <div class="img-text-contain">
                        <img class="no-card" src="@/assets/img/no-card.png" alt="" />
                        <p class="other">暂无可用银行卡</p>
                    </div>
                </div>
            </div>
            <div
                v-if="$util.getConfig().hideFunc && $util.getBusinessModule('0A3')"
                :class="'bank-card-add ' + (bankInfo.length > 2 ? 'margin-top-16' : '')"
                v-on:click="$router.push({ name: 'addbank' })"
            >
                <div class="img-text-contain">
                    <i
                        style="color: var(--color-primary); font-size: 22px"
                        class="el-icon-circle-plus"
                    ></i>
                    <p class="other">新增银行卡</p>
                </div>
            </div>
        </div>
        <div class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">可选银行</div>
        </div>
        <support-bank
            v-if="paychannelbankInfoList.length > 0"
            :paychannelbank-info-list="paychannelbankInfoList"
        ></support-bank>
        <el-dialog
            title="银行卡删除"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>该操作会进行交易账户销户操作，是否确认</span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a">忘记密码？</span>
                        </span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取消</el-button>
                <el-button type="primary" v-on:click="deleteBankCon(deleteId, payCenterId)">
                    删除
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import SupportBank from "@/bizcomponents/bank/supportBankDc.vue";
import userApi from "@/api/user";
import fundApi from "@/api/fund";

export default {
    name: "BankDc",
    components: {
        SupportBank
    },
    mixins: [mixin],
    data() {
        return {
            bankInfo: [],
            dialogVisible: false,
            visible: false,
            isPwdCheck: false,
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            deleteId: "",
            payCenterId: "",
            totalasset: 0,
            paychannelbankInfoList: [],
            changeCardDisplay: false // 换卡管理是否展示
        };
    },
    mounted() {
        this.getBankInfo();
        const accountInfo = this.$cache.getParamValue("account_info");
        if (accountInfo && accountInfo.showchangebankcard) {
            this.changeCardDisplay = true;
        }
    },
    methods: {
        // 查询
        getBankInfo() {
            if (this.$cache.getBinded()) {
                // 我的银行卡
                userApi
                    .getBankCardList()
                    .then(({ bankList, paychannelbankInfoList }) => {
                        this.bankInfo = bankList;
                        this.paychannelbankInfoList = paychannelbankInfoList;
                    })
                    .catch(() => {
                        this.bankInfo = [];
                        this.paychannelbankInfoList = [];
                    });
                // 可用银行（由新增银行卡的BankOperation缩减）
                // this.paychannelbankInfoList = [];
                // this.$util.getBankInfo({ biztype2: "add-multi" }, (bankListsAll, bankLists8) => {
                //     if (this.$cache.getUser().certificatetype === "0B") {
                //         this.paychannelbankInfoList = bankLists8;
                //     } else {
                //         this.paychannelbankInfoList = bankListsAll;
                //     }
                // });
            }
        },
        // 换卡
        async toChangeCard(bankInfo) {
            if (bankInfo.hkcardflag == "1") {
                this.$message.warning(
                    "为保障您的账户安全，换卡业务只针对开通了线上支付的银行卡开放！"
                );
                return;
            }

            const params = { paychannel: bankInfo.paycenterid };
            if (this.$cache.getIsEncrypted()) {
                params.en_depositcard = bankInfo.en_desendepositcard;
            } else {
                params.depositcard = bankInfo.desendepositcard;
            }
            const preRes = await userApi.combBankCardPrepare(params, this.$cache.getIsEncrypted());
            if (preRes && preRes.data) {
                if (preRes.data.fourpermissionflag == 0) {
                    this.$message.warning("该银行卡不允许换卡！");
                    return;
                }
                if (preRes.data.fourpermissionflag == 1 && preRes.data.haspermissionflag == 1) {
                    bankInfo.needFile = 0;
                    this.$router.push({
                        name: "changecard",
                        query: bankInfo
                    });
                } else {
                    bankInfo.needFile = 1;
                    const res = await fundApi.getHoldingAssets({});
                    if (res.data && res.data.first) {
                        this.totalasset = res.data.first.totalasset || 0;
                        if (Number(this.totalasset) > 100000) {
                            this.$message.warning("该银行卡不允许换卡！");
                        } else {
                            this.$router.push({
                                name: "changecard",
                                query: bankInfo
                            });
                        }
                    }
                }
            }
        },
        // 解绑
        deleteBank(id, payCenterId, signstatus) {
            // if ((payCenterId == "0103" || payCenterId == "0113") && signstatus == "1") {
            //     this.$alert("该银行卡需解约后才能进行解绑操作！", "", {
            //         confirmButtonText: "确定",
            //         type: "warning",
            //         callback: (action) => {
            //             if (action == "confirm") {
            //                 this.$router.push({ name: "signandunsign" });
            //             }
            //         }
            //     });
            //     return;
            // }
            this.deleteId = id;
            this.payCenterId = payCenterId;
            this.dialogVisible = true;
            this.$util.queryValidPwdTrdMethod("0B6", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        deleteBankCon(id, payCenterId) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    _this.dialogVisible = false;
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const res = await userApi.delCardPayChannel({
                        bankcardid: id,
                        paychannel: payCenterId,
                        tradepassword: _pwd
                    });
                    if (res.code === "0") {
                        _this.dialogVisible = false;
                        _this.getBankInfo();
                        _this.$message({
                            type: "success",
                            message: "银行卡删除成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 激活
        activeHandle(bank) {
            this.$router.push({
                name: "activebank",
                query: {
                    id: bank.bankcardid
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
/* 用户持有银行卡信息 */
.bizcomp-hold-bank {
    overflow: hidden;
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                color: var(--color-primary);
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .redemp-btn {
        margin-left: 3%;
    }
    .manage-bank {
        text-align: center;
        font-size: $f18;
        line-height: 30px;
        padding: 20px 0;
        border-top: 1px solid $border-color3;
    }
    .hold-bank-list-contain {
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        margin-top: 16px;
        .bank-card-add {
            width: 370px;
            height: 180px;
            border-radius: 8px;
            background: #ffffff;
            box-sizing: border-box;
            border: 1px solid var(--color-divided);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .img-text-contain {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .no-card {
                width: 36px;
                height: 36px;
                border-radius: 50%;
            }
            .other {
                margin-left: 6px;
                font-size: 16px;
                font-weight: normal;
                color: var(--color-primary);
            }
        }
    }
    .hold-bank-list {
        .bank-card {
            cursor: pointer;
            width: 370px;
            height: 180px;
            box-sizing: border-box;
            border-radius: 8px;
            opacity: 1;
            background: linear-gradient(
                296deg,
                color-mix(in srgb, var(--color-primary) 90%, white) 1%,
                color-mix(in srgb, var(--color-primary) 85%, black) 100%
            );
            .bank-info {
                padding: 16px;
                box-sizing: border-box;
                display: flex;
                .bank-img {
                    width: 50px;
                    height: 50px;
                    padding: 7px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    background: #ffffff;
                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }
                .bank-name {
                    margin-left: 10px;
                    display: inline-block;
                    vertical-align: middle;
                    span {
                        display: block;
                        &.t {
                            height: 24px;
                            font-size: 18px;
                            font-weight: bold;
                            color: #ffffff;
                        }
                        &.c {
                            height: 20px;
                            font-size: 14px;
                            font-weight: normal;
                            color: #ffffff;
                        }
                    }
                    .flex {
                        display: flex;
                    }
                    .ml-10 {
                        margin-left: 10px;
                    }
                }
            }
            .bank-num {
                height: 30px;
                font-size: 22px;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
            }

            .bank-action {
                padding-top: 20px;
                padding-right: 16px;
                text-align: right;
                .bank-btn {
                    width: 70px;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 2px;
                    box-sizing: border-box;
                    border: 1px solid #ffffff;
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    color: #ffffff;
                    background-color: var(--color-primary);
                    margin-left: 10px;
                    cursor: pointer;

                    &.bank-btn-disabled {
                        cursor: not-allowed;
                        background-color: rgb(137, 137, 137, 0.85);
                        border-color: #e9e9e9;
                        color: #eaeaea;
                    }
                }
            }
        }
    }
    .bar-contain {
        display: flex;
        align-items: center;
        margin: 36px 0 16px;
        &:first-child {
            margin-top: 0;
        }
        .bar {
            width: 3.71px;
            height: 16.73px;
            background: var(--color-primary);
        }
        .bar-text {
            margin-left: 6.29px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
    }
    .margin-top-16 {
        margin-top: 16px;
    }
    .margin-right-25 {
        margin-right: 25px;
    }
}
/* 可选银行 */
//.bizcomp-support-bank-dc {
//    display: flex;
//    flex-wrap: wrap;
//    .bank-img {
//        height: 68px;
//        width: 219px;
//        display: flex;
//        align-items: center;
//        padding-left: 27px;
//        border-radius: 2px;
//        background: #ffffff;
//        box-sizing: border-box;
//        border: 1px solid #e4e4e4;
//        img {
//            width: 36px;
//            height: 36px;
//        }
//        span {
//            font-size: 20px;
//            font-weight: 500;
//            font-feature-settings: "kern" on;
//            color: #3d3d3d;
//            padding-left: 8px;
//        }
//    }
//    .margin-right-16 {
//        margin-right: 16px;
//    }
//    .margin-top-16 {
//        margin-top: 16px;
//    }
//}
</style>
